module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard2-step1.1006720f.png";